/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Circle, Line } from 'react-native-svg';

import { IconProps } from '../lib';

function MagnifyingGlass(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256.00098 256.00098"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Circle
        cx={115.99707}
        cy={116}
        r={84}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Line
        x1={175.39063}
        y1={175.40039}
        x2={223.99121}
        y2={224.00098}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
    </Svg>
  );
}

export default MagnifyingGlass;
